import script from "./checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./checkbox.vue?vue&type=style&index=0&id=3675aa29&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3675aa29"]])

export default __exports__